/**
* this is the component for the What am Invested in Section
*
* Created by Butterfly on 20/08/18
*/

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from '../../config'
import moment from 'moment'
import { PieChart } from 'react-easy-chart';

// action import
import { ActionCreator } from '../../actions/'

// style import
import './style.scss'


class Investment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            effectiveWidth: 0,
            showToolTip: false,
            toolTipText:"",
            top: `0px`,
            left: `0px`,
            y: "",
            x:"",
        }
        this._determineWidth = this._determineWidth.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this._determineWidth, false)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._determineWidth, false)
    }

    componentDidUpdate(prevProps, prevState) {

        const { effectiveWidth } = this.state
        const { openRightMenu } = this.props

        if((prevState.effectiveWidth !== effectiveWidth) || (effectiveWidth === 0))
            this._determineWidth()

        if(prevProps.openRightMenu !== openRightMenu)
            this._determineWidth()
    }

    _determineWidth() {
        const { effectiveWidth } = this.state

        setTimeout(() => {
            const screenSize = window.innerWidth;

            const width = document.getElementsByClassName("dashboard__display-box")[0].offsetWidth

            if(screenSize < 720)
                this.setState({effectiveWidth: ((width - 80) * 0.5)})

            if(screenSize > 720 && screenSize < 1101) //tablet size
                this.setState({effectiveWidth: ((width - 220) * 0.36)})

            if(screenSize > 1100)
                this.setState({effectiveWidth: ((width - 240) * 0.38)})
        }, 0)

    }

    // Mouse handler for chart helptext when hover
    _mouseOverHandler(d, e) {

      ::this.setState({showToolTip: true,
          top: `${e.clientY }px`,
          left: `${e.clientX + 20}px`,
          toolTipText: d.data.key + " " +d.data.value+"%",
          y: d.y,
          x: d.x});

    }

    _mouseMoveHandler(e) {
      if (this.state.showToolTip) {

        ::this.setState({
            top: `${e.clientY}px`,
            left: `${e.clientX + 20}px`
        });

      }
    }

    _mouseOutHandler() {
      ::this.setState({
          showToolTip: false,
          toolTipText:""
      });

    }

    render() {

        const { iData } = this.props
        const { effectiveWidth, toolTipText, left, top, showToolTip } = this.state
        const todayDate = moment().format("YYYY-MM-DD")
        const downloadURL = config.endpoints.investmentDownloadURL + todayDate
        let iChartData = []
        let iChartColors = ["#6ca5ea", "#b999b1", "#4638d0", "#160f71", "#0c042e", "#424766", "#e1eaf8", "#1bafaf", "#39d4d8", "#c2d9ff"];
        let count = 0;

        for (var i in iData) {
            iChartData.push({
                value: iData[i].asset_strategy_overall_percent,
                key: iData[i].asset_class_name,
                color: iChartColors[count]
            })
            if(count === (iChartColors.length - 1)){
                count = 0;
            }else{
                count ++;
            }
        }

        const investmentList = iChartData.map((investment, index) =>
            <li className="investment__data-container__list__row" key={ index } style={{ color: investment.color }}>
              <span className="investment__data-container__list__row__name"><span className="investment__data-container__list__row__tag" ></span>{ investment.key }</span>
              <span className="investment__data-container__list__row__value">{ investment.value }%</span>
            </li>
        );

        return (
            <div className="investment">

                {/* header container*/}
                <div className="investment__header">

                    <div className="investment__header__title">
                        <p>WHAT AM I INVESTED IN?</p>
                    </div>

                    <div className="investment__header__asset-allocation">
                        <a href={ downloadURL } target="_blank" className="investment__header__asset-allocation__button">
                            Asset allocation
                        </a>
                    </div>

                </div>

                <div className="investment__data-container">

                    {/* https://github.com/rma-consulting/react-easy-chart */}
                    <div className="investment__data-container__chart" style={{ height:effectiveWidth+60, }}>

                        <PieChart
                            data={ iChartData }
                            size={ effectiveWidth }
                            mouseOverHandler={ ::this._mouseOverHandler }
                            mouseOutHandler={ ::this._mouseOutHandler }
                            mouseMoveHandler={ ::this._mouseMoveHandler }
                            innerHoleSize={ effectiveWidth * 0.57 }

                        />
                        <div style={ {left:left, top:top} } className={"investment__data-container__chart__helptext "+(showToolTip ? 'show' : 'hidden')}>
                            { toolTipText }
                        </div>

                    </div>
                    <div className="investment__data-container__list">
                        <ul className="investment__data-container__list__wrapper">
                            { investmentList }
                        </ul>
                    </div>

                </div>

            </div>
        )
    }
}

// define the prop types
Investment.propTypes = {
    iData: PropTypes.array,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        iData: state.investmentState.data,
        openRightMenu: state.componentState.openRightMenu
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getInvestmentData: action.getInvestmentData,
        setOpenRightMenu: action.setOpenRightMenu
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Investment)



// WEBPACK FOOTER //
// ./src/components/Investment/index.js